export default __webpack_public_path__ + "static/media/left-arrow.44c183d3.svg";